export const getSchemaOrgAggregateRating = ({ reviews }) =>
  reviews.length
    ? {
        '@type': 'AggregateRating',
        ratingCount: reviews.length,
        reviewCount: reviews.length,
        ratingValue: '5',
        itemReviewed: {
          '@type': 'Organization',
          name: 'Wooclap',
        },
      }
    : {};
